/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useRef, useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {ReactComponent as Plan} from "../../assets/img/pricing/plan.svg";
import {ReactComponent as CheckGreen} from "../../assets/img/pricing/check-green.svg";
import {ReactComponent as BestChoise} from "../../assets/img/forms/best.svg";
import {Link, useParams} from "react-router-dom";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import Loader from "../../elements/loader";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const Pricing = () => {

    const ref = useRef();
    const params = useParams();
    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();

    const [activePlan, setActivePlan] = useState([]);
    const [subscriptions, setSubscriptions] = useState({isLoading: true, data: [], error: false});
    const [trigger, setTrigger] = useState(false);

    const data = {
        title: 'Pricing',
        subtitle: ''
    };
    const faqs = [
        {
            title : 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
            content : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam'
        },
        {
            title : 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
            content : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam'
        },
        {
            title : 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
            content : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam'
        },
        {
            title : 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
            content : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam'
        }
    ];
    const plans = [
        { value: '0', label: 'Subscription for 3 months - 120€' },
        { value: '1', label: 'Subscription for 6 months - 210€' },
        { value: '2', label: 'Subscription for 9 months - 320€' },
    ];
    const dataPlans = [
        {value : '0', price: '120', period: '3 months'},
        {value : '1', price: '210', period: '6 months'},
        {value : '2', price: '320', period: '9 months'},
    ]

    function handleChange(e, subscription_id){

        let _plan = JSON.parse(e.target.value);

        const newArray = [...activePlan];
        newArray[subscription_id] = _plan;
        setActivePlan(newArray);
    }

    const getSubscriptions = (signal) => {
        axiosJWT.post('/api/getsubscriptions', null, {signal}).then( (response) => {

            if(response.data.success){

                setSubscriptions({...subscriptions, data: response.data.subscriptions|| [], isLoading: false});
                setTrigger(true); //Κανω trigger για να βαλω το selected

            }

        } ).catch((error) => {
            console.log(error);
            setSubscriptions({...subscriptions, error: true, isLoading: false});
        });
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        //getSubscriptions(signal);

        return () => {controller.abort();}
    }, [params]);

    useEffect(() => {

        let newArray =  new Array();
        for(let i = 0; i < subscriptions.data.length; ++i ){
            if( subscriptions.data[i].pricing.length > 0){
                for(let y = 0; y < subscriptions.data[i].pricing.length; ++y ){
                    if( subscriptions.data[i].pricing[y].selected ==  1){
                        newArray[`${subscriptions.data[i].subscription_id}`] = subscriptions.data[i].pricing[y];
                        setActivePlan(newArray);
                    }
                }
            }
        }

    }, [trigger]);

    return (
        <PageBox data={data} small={true}>
            <SEO
                title={ t('meta_title.pricing' )}
                description={ t('meta_description.pricing' ) }
            />
            <div className='Pricing'>
                <div className='Pricing__header'>
                    <div className='Pricing__head'>
                        <div className='Pricing__title'>Discmantlers Plans Subscription</div>
                        <div className='Pricing__subtitle'>{t('pricing.pricingText')}</div>
                    </div>
                </div>
                <div className='Pricing__body'>
                    <div className='PricingPlan--container'>
                        <div className='row'>
                            {subscriptions.isLoading ? (
                                <>
                                    <div style={{ paddingTop: '100px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                                    { subscriptions.error && <div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>An error occurred please try again later.</div>}
                                </>

                            ) : (
                                subscriptions.data.map( (subscription, index) => (
                                    <div className='col-lg' key={index}>
                                        <div className={`PricingPlan PricingPlan--${subscription.subscription_id}`}>
                                            <div className='PricingPlan__icon'><Plan/></div>
                                            <div className='PricingPlan__title'>{subscription.title}</div>
                                            <div className='PricingPlan__sep-text'></div>
                                            {/*<div className='PricingPlan__price'><span>€</span>{Math.floor( parseInt(subscription.price) )} </div>*/}
                                            <div className='PricingPlan__price'><span>€</span> {activePlan[subscription.subscription_id] && <>{activePlan[subscription.subscription_id].price}</>} </div>
                                            <div className='PricingPlan__sep-text mb-3'> {activePlan[subscription.subscription_id] && <>{activePlan[subscription.subscription_id].subtitle}</> } </div>

                                            { Array.isArray(subscription.pricing) && subscription.pricing.length > 0 &&
                                                <select className={`form-control PricingPlan__select`} defaultValue={activePlan[subscription.subscription_id]}  onChange={event => handleChange(event, subscription.subscription_id)}>
                                                    <option value="" disabled>{t('fields.Select')}</option>
                                                    { subscription.pricing.map((option, i) => (
                                                        <option key={i} value={JSON.stringify(option)}>{option.price}€ {option.subtitle}</option>
                                                    )) }
                                                </select>
                                            }

                                            <Link to={`/${i18n.language}/checkout/${ activePlan[subscription.subscription_id] ? `?price_id=${activePlan[subscription.subscription_id].subscriptions_pricing_id}` : "" }`} className={`btn btn-primary btn-block btn-pricingSubscribe ${activePlan ? "" :"disabled"} `}>
                                                {t('pricing.subscribeBtn')}
                                            </Link>

                                            <div className={`PricingPlan__footer border-none`}>
                                                <div className="mixed-link">
                                                    <div className="mixed-link__text">{t('pricing.startTrial')} </div>
                                                    <Link to={`/${i18n.language}/checkout/?price_id=${subscription.free_trial}`} className="mixed-link__link">{t('pricing.startTrialLink')}</Link>
                                                </div>
                                            </div>

                                            <div className='PricingPlan__text'>{subscription.description}</div>

                                            <div className='checklist'>
                                                { Array.isArray(subscription.benefits) && subscription.benefits.map( (benefit, index) =>(
                                                    <div className='checklist__item icon-link' key={index}>
                                                        <div className='checklist__icon'><CheckGreen/></div>
                                                        <div className='checklist__text'>{benefit.description}</div>
                                                    </div>
                                                ) ) }
                                            </div>

                                            {/*<div className={`PricingPlan__footer ${subscription.subscription_id == 4 ? "d-none" : ""} `}>*/}
                                            {/*    <div className="mixed-link">*/}
                                            {/*        <div className="mixed-link__text">or start with a </div>*/}
                                            {/*        <Link to={`/${i18n.language}/checkout`} className="mixed-link__link">FREE trial</Link>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                        </div>
                                    </div>
                                ) )

                            )}

                            {/*<div className='col-md-6'>*/}

                            {/*    <div className='PricingPlan'>*/}
                            {/*        <div className='PricingPlan__icon'><Plan/></div>*/}
                            {/*        <div className='PricingPlan__title'>Standard</div>*/}
                            {/*        <div className='PricingPlan__sep-text'></div>*/}
                            {/*        <div className='PricingPlan__price'><span>€</span>300</div>*/}
                            {/*        <div className='PricingPlan__sep-text mb-3'>per year</div>*/}

                            {/*        <Link to={`/${i18n.language}/checkout`} className='btn btn-primary btn-block btn-pricingSubscribe'>Subscribe Now</Link>*/}

                            {/*        <div className='PricingPlan__text'>For 300 Ad Listings. If you need more Ads the cost is 150€/ 300 Ads.</div>*/}

                            {/*        <div className='PricingPlan__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt</div>*/}

                            {/*        <div className='checklist'>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste na</div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='ichecklist__text'>Sed ut perspiciatis unde omnis iste natus </div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste natus </div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className='PricingPlan__footer'>*/}
                            {/*            <div className="mixed-link">*/}
                            {/*                <div className="mixed-link__text">or start with a </div>*/}
                            {/*                <a href="#" className="mixed-link__link">FREE trial</a>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*    </div>*/}

                            {/*</div>*/}
                            {/*<div className='col-md-6'>*/}

                            {/*    <div className='PricingPlan'>*/}
                            {/*        { dataPlans[activePlan].value == 2 &&<div className='PricingPlan__best'><BestChoise/></div>}*/}
                            {/*        <div className='PricingPlan__icon'><Plan/></div>*/}
                            {/*        <div className='PricingPlan__title'>Seller</div>*/}
                            {/*        <div className='PricingPlan__sep-text'>from</div>*/}
                            {/*        <div className='PricingPlan__price'><span>€</span>{ dataPlans[activePlan].price }</div>*/}
                            {/*        <div className='PricingPlan__sep-text mb-3'>per { dataPlans[activePlan].period }</div>*/}

                            {/*        <InputSelect class='PricingPlan__select' placeholder='' options={plans} onChange={handleChange} />*/}

                            {/*        <Link to={`/${i18n.language}/checkout`} className='btn btn-primary btn-block btn-pricingSubscribe'>Subscribe Now</Link>*/}

                            {/*        <div className='PricingPlan__text'>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt</div>*/}

                            {/*        <div className='checklist'>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste na</div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='ichecklist__text'>Sed ut perspiciatis unde omnis iste natus </div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste natus </div>*/}
                            {/*            </div>*/}
                            {/*            <div className='checklist__item icon-link'>*/}
                            {/*                <div className='checklist__icon'><CheckGreen/></div>*/}
                            {/*                <div className='checklist__text'>Sed ut perspiciatis unde omnis iste </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*        <div className='PricingPlan__footer'>*/}
                            {/*            <div className="mixed-link">*/}
                            {/*                <div className="mixed-link__text">or start with a </div>*/}
                            {/*                <a href="#" className="mixed-link__link">FREE trial</a>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}

                            {/*    </div>*/}

                            {/*</div>*/}

                        </div>
                    </div>

                    <div className='PricingFaq--container'>
                        <div className='PricingFaq__small-title'>*{t('pricing.priceLabel')}</div>
                        {/*<div className='row'>*/}
                        {/*    <div className='col-md-5'>*/}
                        {/*        <div className='PricingFaq__uptitle'>KNOW WHAT YOU’RE GETTING</div>*/}
                        {/*        <div className='PricingFaq__title'>A Few Frequently Asked Questions</div>*/}
                        {/*    </div>*/}
                        {/*    <div className='col-md-7'>*/}
                        {/*        {*/}
                        {/*            faqs.map((faq, index) =>*/}
                        {/*                <FaqAccordion title={faq.title} content={faq.content} key={index}/>*/}
                        {/*            )*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>



                </div>
            </div>

        </PageBox>
    );
};

export default Pricing;
